import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';

import { keyCode } from '@ridango/core/lib/enums/keyboard.enum';

@Component({
    selector: 'ridango-calendar-controls',
    templateUrl: './calendar-controls.component.html',
    styleUrls: ['./calendar-controls.component.scss'],
})
export class CalendarControlsComponent {
    @Input() date;
    @Input() yearsControl = true;
    @Input() monthsControl = true;
    @Input() lang = 'en';

    @Output() onDateChange = new EventEmitter<Date>();
    @Output() onKeyDown = new EventEmitter<keyCode>();

    @ViewChildren('control') controls: QueryList<ElementRef>;

    months = [
        'LOCAL_CALENDAR_JANUARY_MMMM',
        'LOCAL_CALENDAR_FEBRUARY_MMMM',
        'LOCAL_CALENDAR_MARCH_MMMM',
        'LOCAL_CALENDAR_APRIL_MMMM',
        'LOCAL_CALENDAR_MAY_MMMM',
        'LOCAL_CALENDAR_JUNE_MMMM',
        'LOCAL_CALENDAR_JULY_MMMM',
        'LOCAL_CALENDAR_AUGUST_MMMM',
        'LOCAL_CALENDAR_SEPTEMBER_MMMM',
        'LOCAL_CALENDAR_OCTOBER_MMMM',
        'LOCAL_CALENDAR_NOVEMBER_MMMM',
        'LOCAL_CALENDAR_DECEMBER_MMMM',
    ];

    currentControl = 0;

    constructor(public eRef: ElementRef) {}

    setFocus(isLast = false): void {
        this.currentControl = isLast ? this.controls.length - 1 : 0;
        setTimeout(() => this.controls.toArray()[this.currentControl].nativeElement.focus());
    }

    moveFocusForward(): void {
        const index = ++this.currentControl;
        if (index >= this.controls.length) {
            this.currentControl = this.controls.length - 1;
            this.onKeyDown.emit(keyCode.TAB);
        } else {
            setTimeout(() => this.controls.toArray()[index].nativeElement.focus());
        }
    }

    moveFocusBackward(): void {
        const index = --this.currentControl;
        if (index < 0) {
            this.currentControl = 0;
            this.onKeyDown.emit(keyCode.TAB);
        } else {
            setTimeout(() => this.controls.toArray()[index].nativeElement.focus());
        }
    }

    handleKeydown(event: KeyboardEvent): void {
        switch (event.keyCode) {
            case keyCode.TAB:
                if (event.shiftKey) {
                    this.moveFocusBackward();
                } else {
                    this.moveFocusForward();
                }
                break;
            case keyCode.ESCAPE:
                this.onKeyDown.emit(keyCode.ESCAPE);
                break;
        }

        event.stopPropagation();
        event.preventDefault();
    }

    incrementMonth(): void {
        let year = this.date.getFullYear();
        let month = this.date.getMonth();
        month += 1;
        if (month === 12) {
            year += 1;
            month = 0;
        }
        const d = new Date();
        d.setDate(1);
        d.setMonth(month);
        d.setFullYear(year);
        this.onDateChange.emit(d);
    }

    decrementMonth(): void {
        let year = this.date.getFullYear();
        let month = this.date.getMonth();
        month -= 1;
        if (month === -1) {
            month = 11;
            year -= 1;
        }
        const d = new Date();
        d.setDate(1);
        d.setMonth(month);
        d.setFullYear(year);
        this.onDateChange.emit(d);
    }

    incrementYear(): void {
        let year = this.date.getFullYear();
        year += 1;
        this.date.setFullYear(year);
        this.onDateChange.emit(this.date);
    }

    decrementYear(): void {
        let year = this.date.getFullYear();
        year -= 1;
        this.date.setFullYear(year);
        this.onDateChange.emit(this.date);
    }
}
